<template>
  <ModalWrapper>
    <template #header-text>
      <span>Вход или регистрация</span>
    </template>
    <template #default>
      <form
        class="enter-phone"
        @submit.prevent="onSubmit"
      >
        <VueRecaptcha
          ref="recaptcha"
          size="invisible"
          :sitekey="googleApiKey"
          @verify="onCaptchaVerified"
          @expired="onCaptchaExpired"
        />
        <div class="enter-phone__title">
          Ваш телефон
        </div>
        <div
          class="enter-phone__phone"
          :class="{ 'enter-phone__phone--mobile': $isSmartphone }"
        >
          <span class="enter-phone__phone-country-code">+7</span>
          <input
            ref="input"
            v-model="phoneNumber"
            v-mask="'### ### ## ##'"
            class="enter-phone__phone-input"
            type="tel"
            @focus="(errorMessage = ''),(phoneNumberError = false), (isButtonDisabled = false)"
          >
          <transition
            name="fade"
            :duration="300"
          >
            <div
              v-if="phoneNumberError"
              class="enter-phone__phone-error-msg"
            >
              Введите номер телефона
            </div>
          </transition>
          <transition
            name="fade"
            :duration="300"
          >
            <div
              v-if="errorMessage !== ''"
              class="enter-phone__phone-error-msg"
            >
              {{ errorMessage }}
            </div>
          </transition>
        </div>
        <c-btn
          :w100="false"
          disable-style
          :is-loading="loadingSms"
          class="enter-phone__btn enter-phone__btn--green"
          :class="{
            'enter-phone__btn--mobile': $isSmartphone
          }"
          :disabled="isButtonDisabled"
        >
          <span class="enter-phone__btn-text">
            Далее
          </span>
        </c-btn>
        <div
          class="enter-phone__polit"
          :class="{ 'enter-phone__polit--mobile': $isSmartphone }"
        >
          Нажимая кнопку "Далее", Вы соглашаетесь с
          <a
            class="enter-phone__info-protector-link"
            :href="Visual.baseOferta"
            target="_blank"
          >условиями оферты</a> и даете согласие на
          <a
            class="enter-phone__info-protector-link"
            :href="personalDataDoc"
            target="_blank"
          >обработку персональных данных</a>
          <!-- <span
            class="enter-phone__info-protector-link"
            @click="openModal('Info')"
          >Пользовательского соглашения</span> -->
        </div>
      </form>
    </template>
  </ModalWrapper>
</template>

<script>
import { mapGetters, mapMutations, mapActions } from 'vuex'
import { VueRecaptcha } from 'vue-recaptcha'
// constants
import { CONSENT_TO_DATA_PROCESSING, OrderOriginIds } from '@/config/constants.js'
// services
// import { hasNineOrIsHome } from '@/services/vuelidate/validations/phone'
import { mapVCP } from '@/services/mapVCP'
import apiOrder from '@/api/orders'

import ModalWrapper from './ModalWrapper'
import Cookies from 'js-cookie'

export default {
  components: {
    ModalWrapper,
    VueRecaptcha,
  },

  props: {
    /**
     * @description Hook для enter sms modal
     */
    params: {
      type: Object,
      default () {
        return null
      },
    },
  },

  data () {
    return {
      phoneNumberError: false,
      errorMessage: '',
      phoneNumber: this.params?.phone || '',
      isButtonDisabled: false,
      isFirstTry: false,
      googleApiKey: process.env.VUE_APP_GOOGLE_API_KEY_TEST,
      loadingSms: false,
      recaptchaToken: null,
    }
  },

  computed: {
    ...mapVCP({
      Visual: ['Visual', {}],
    }),
    ...mapGetters({
      activeCity: 'city/getActive',
    }),
    personalDataDoc () {
      return this.visual?.personalDataDoc || CONSENT_TO_DATA_PROCESSING
    },
  },
  watch: {
    phoneNumber () {
      if (this.phoneNumber.length === 13) {
        this.createForgottenOrder()
      }
    },
  },

  mounted () {
    if (this.params?.phone) {
      if (this.params?.phone.slice(0, 2) === '+7') {
        this.phoneNumber = this.params?.phone.slice(2)
      } else {
        this.phoneNumber = this.params?.phone
      }
    } else {
      this.phoneNumber = ''
    }

    this.$refs.input.focus()
  },
  methods: {
    ...mapMutations({
      openModal: 'modals/openModal',
      closeModal: 'modals/closeModal',
    }),
    ...mapActions({
      sendSms: 'client/sendSms',
    }),
    phoneNumberCheck () {
      if (
        this.phoneNumber.replaceAll(' ', '').length !== 10 ||
        +this.phoneNumber[0] !== 9
      ) {
        this.phoneNumberError = true
      } else {
        this.phoneNumberError = false
      }
    },
    onSubmit () {
      this.phoneNumberCheck()
      if (this.phoneNumberError) {
        // this.$v.phone.$touch()
        this.isButtonDisabled = true
        this.$store.dispatch('analytics/singleEvent', 'send_phone_error', { root: true })
      } else {
        this.sendPhone()
      }
    },
    onCaptchaVerified (response) {
      this.recaptchaToken = response
      this.sendPhone()
      this.$refs.recaptcha.reset()
      this.recaptchaToken = null
    },
    sendPhone () {
      if (this.$isSmartphone) {
        this.$store.dispatch('analytics/singleEvent', 'mob_order_send_sms', { root: true })
      } else {
        this.$store.dispatch('analytics/singleEvent', 'order_send_sms', { root: true })
      }
      // send phone
      this.isButtonDisabled = true
      this.loadingSms = true

      const requestData = { phone: this.phoneNumber, bftucid: Cookies.get('bftucid') }
      if (this.recaptchaToken) {
        requestData.recaptchaToken = this.recaptchaToken
      }

      this.sendSms(requestData)
        .then(res => {
          if (this.params.openCheckoutForm) {
            this.$gtm.trackEvent({
              event: 'go_to_step',
              step_number: 2,
              step_option: '',
              form_placement: 'basket',
            })
          }
          const configModal = {
            name: 'EnterSms',
            params: {
              phone: this.phoneNumber,
              openCheckoutForm: this.params?.openCheckoutForm,
              afterLogIn: this.params?.afterLogIn,
            },
          }

          if (res.client_token && this.params?.afterLogIn) {
            this.params.afterLogIn()
          } else {
            this.openModal(configModal)
          }

          if (res.client.isNew) {
            this.isFirstTry = true
          }
          this.isButtonDisabled = false

          this.loadingSms = false
          this.closeModal('EnterPhone')
        })
        .catch(error => {
          const errorMessage = error?.response?.data?.messages[0] || 'Ошибка на сервере'
          if (this.$isSmartphone) {
            this.$store.dispatch('analytics/singleEvent', 'mob_send_phone_server_error', { root: true })
          } else {
            this.$store.dispatch('analytics/singleEvent', 'send_phone_server_error', { root: true })
          }
          if (errorMessage === 'enable_captcha') {
            this.$refs.recaptcha.execute()
            return
          }

          this.isButtonDisabled = false
          this.loadingSms = false
          this.errorMessage = errorMessage
          // this.showError = true
          this.closeModal('EnterSms')
        })
    },
    onCaptchaExpired () {
      this.$refs.recaptcha.reset()
    },
    async createForgottenOrder () {
      if (this.params.price && this.params.openCheckoutForm) {
        this.$gtm.trackEvent({
          event: 'input_phone',
          form_placement: 'basket',
          order_price: this.params.price,
        })
      }

      const mealDays = this.params.menuDays || 6
      const pricePlanId = this.params.pricePlanId || 373
      try {
        await apiOrder.createForgottenOrder({
          order: {
            mealDays,
            phone: `+7 ${this.phoneNumber}`,
            price_plan_id: pricePlanId,
            order_origin_id: OrderOriginIds.LANDING_UNAUTHORIZED,
          },
          client: {
            cityId: this.activeCity?.id,
            phone: `+7 ${this.phoneNumber}`,
          },
          isFromReferral: false,
          delayInMinutes: 10,
        })
      } catch (error) {
        console.log(error)
      }
    },
  },
}
</script>

<style lang="scss">
.enter-phone {
  position: relative;
  // height: 100%;
  width: calc(100% - 0.24rem);
  padding: 0.32rem 0;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  &__header-title {
    margin: 0 auto 0.16rem;
  }
  &__title {
    // margin-top: auto;
    margin-bottom: 0.52rem;
    font-style: normal;
    font-weight: normal;
    font-size: 0.2rem;
    line-height: 0.24rem;
    text-align: center;
  }
  &__phone {
    position: relative;
    display: flex;
    // align-items: flex-end;
    padding: 0.04rem;
    margin: 0 auto 0.16rem;
    // border-bottom: 2px solid #000000;
    font-weight: 300;
    font-size: 0.3rem;
    line-height: 0.38rem;
    letter-spacing: 0.0132719rem;
    width: 2.58rem;
    &--mobile {
      // width: calc(100% - 0.25rem);
      width: 2.8rem;
    }
    &:after {
      content: '';
      position: absolute;
      top: 100%;
      width: 100%;
      left: 0;
      right: 0;
      height: 2px;
      border-radius: 2px;
      background: map-get($colors, 'black_0');
    }
    &-country-code {
      color: #8e8e93;
      margin-right: 0.09rem;
    }
    &-input {
      padding: 0;
      margin: 0;
      border: none;
      color: map-get($colors, 'black_0');
      width: 100%;
      caret-color: map-get($colors, 'default');
      font-size: inherit;
      &:focus {
        outline: none;
      }
    }
    &-error-msg {
      position: absolute;
      top: calc(100% + 0.16rem);
      left: 0;
      width: 100%;
      text-align: center;
      font-size: 0.12rem;
      line-height: 0.14rem;
      font-weight: 400;
      letter-spacing: .00497696rem;
      color: map-get($colors, 'red_error');
    }
  }
  &__btn {
    position: relative;
    display: flex;
    justify-content: center;
    align-items: center;
    margin: 0.24rem auto 0.24rem;
    padding: 0.12rem 0.26rem;
    height: auto !important;
    outline: none !important;
    border: none !important;
    cursor: pointer;
    outline: none;
    font-size: 0.16rem;
    font-weight: 600;
    line-height: 0.19rem;
    border-radius: 100px;
    text-transform: none;
    display: flex;
    justify-content: center;
    align-items: center;
    transition: all 0.3s;
    border: none;
    transition: background-color 0.3s;
    &--mobile {
      width: calc(100% - 0.4rem);
      margin: 0.9rem auto 0.24rem;
    }
    &--green {
      background-color: map-get($colors, 'default');
      color: map-get($colors, 'white');
      &:active {
        background-color: map-get($colors, 'default-light-75');
      }
    }
  }

  &__btn-text {
    transition: opacity 0.3s;
  }
  &__btn-loader {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }
  &__polit {
    width: 100%;
    margin: 0.24rem 0 0;
    text-align: center;
    font-weight: 300;
    font-size: 0.115rem;
    line-height: 0.16rem;
    color: map-get($colors, 'grey_20');
    &--mobile {
      margin: 0.24rem 0 0.96rem;
    }
  }
  &__info-protector-link {
    font-weight: 400;
    color: #8e8e93;
    font-size: 0.115rem;
    line-height: 0.16rem;
  }
}
</style>
